export function getCorners(
	x: number,
	y: number,
	w: number,
	h: number
): {
	topLeftCorner: { x: number; y: number };
	topRightCorner: { x: number; y: number };
	bottomLeftCorner: { x: number; y: number };
	bottomRightCorner: { x: number; y: number };
} {
	return {
		topLeftCorner: { x, y },
		topRightCorner: { x: x + w, y },
		bottomLeftCorner: { x, y: y + h },
		bottomRightCorner: { x: x + w, y: y + h },
	};
}

/*
 * https://roblouie.com/article/617/transforming-mouse-coordinates-to-canvas-coordinates/
 * This method has been modified. The original method doesn't take in account current scale.
 * https://math.hws.edu/graphicsbook/c6/s5.html#webgl.5.1
 * */

export function getTransformedPoint(
	x: number,
	y: number,
	transform: {
		scaleX: number;
		skewY: number;
		skewX: number;
		scaleY: number;
		translationX: number;
		translationY: number;
		initialScale: number;
	}
) {
	const inverseZoom = 1 / (transform.scaleX / transform.initialScale);

	const transformedX =
		inverseZoom * x -
		inverseZoom * (transform.translationX / transform.initialScale);
	const transformedY =
		inverseZoom * y -
		inverseZoom * (transform.translationY / transform.initialScale);
	return { x: transformedX, y: transformedY };
}
